<epmax-popover (onStatusChange)="arrowControl[0] = !arrowControl[0]" #popover placement="bottom" [id]="id" (onStatusChange)="onStatusChange($event)" [reversePlacement]="reversePlacement" >
  <div class="w-100" toggle>
    @if (!toggleText) {
      <epmax-button [class.isMenuOpenActiveClass]="buttonType == 'secondary' && arrowControl[0]" [isOutlinedStartIcon]="showResultIcon ? false : true" [disabled]="disabled" [withBorder]="!!text && withBorder"
        [data-automation-id]="dataAutomationId"
        [typoWeight]="typoWeight"
        [size]="buttonSize" [class]="optionColorIconSelcted"
        [leftIcon]="startIcon" [type]="buttonType" [style]="buttonStyle"
                      [rightIcon]="leftIcon == 'arrow_drop_down' ? (
                        !!!arrowControl[0] ? 'arrow_drop_down' : 'arrow_drop_up'
                      ) : leftIcon"
        [label]="label"
        [bottonType]="buttonActionType" />
      }
      @else {
      <epmax-typo name="body2">{{toggleText}}</epmax-typo>
    }

  </div>
  <div body class="menuContainer radius_md removeBoxShadow">

    <div class="dropdownMenuContainer" [class.width-auto]="!isFixedWidth">
      @for (action of actions; track trackByAction($index, action); let i = $index) {
        @if (showLastItemIndex && i == actions.length - 1) {
          <div class="divider1 divider1__horizontal height-2 mh-2"></div>
        }
        @if (action.showOption != false) {
          <div class="dropdownMenuContainer-item"
            [class.disabled]="action.disabled"
            [attr.data-automation-id]="action?.dataAutomationId"
            [ngClass]="{'disabled': action?.disabled}"
            [title]="!action.tooltip ? '' : (action.tooltip | translate)"
            (click)="!action.disabled && action.event(data,index);getOptionSelctedText(action.title);getOptionSelctedIcon(action.icon, action.iconColor);selectedItem(action)"
            >
            @if (!!action?.image && !action.icon) {
              <epmax-image [src]="action?.image" [size]="24"></epmax-image>
            }
            @if (!!action.icon) {
              <epmax-icon [isOutlined]="action?.isOutlinedIcon"
              [color]="!!action.rightIconColor ? action.rightIconColor : action.iconColor || 'muted'" [name]="action.icon" [size]="action.iconSize"></epmax-icon>
            }
            <epmax-typo name='body1' [weight]="500" color="primary"> {{action.title | translate}}</epmax-typo>
          </div>
        }
      }
    </div>
  </div>
</epmax-popover>
